var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcKakao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.323242C4.9247 0.323242 0 4.14767 0 8.86684C0 11.802 1.9052 14.3883 4.8048 15.9258L3.5849 20.4072C3.56249 20.4957 3.56749 20.5889 3.59924 20.6745C3.631 20.7601 3.688 20.834 3.76269 20.8864C3.83739 20.9388 3.92624 20.9672 4.01747 20.9679C4.1087 20.9687 4.19799 20.9416 4.2735 20.8904L9.6228 17.3411C10.0738 17.3851 10.5336 17.4104 11 17.4104C17.0753 17.4104 22 13.5849 22 8.86684C22 4.14877 17.0753 0.323242 11 0.323242Z",
    fill: "black",
    fillOpacity: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKakao);
export default __webpack_public_path__ + "static/media/ic_kakao.de856947a2fad480e19c31a9506056cc.svg";
export { ForwardRef as ReactComponent };